// Excel column headers of the vacation days (CET) allocation file, by allocation field
export const VACATION_DAYS_FILE_COLUMNS = {
  cet_days: 'Divers',
  rtt_days: 'RTT',
  overtime_days: 'Heures supplémentaires',
  paid_leave_days: 'Congés payés',
  seniority_leave_days: "Congés d'ancienneté",
  untaken_rest_days: 'Jours de repos non pris',
} as const;

// Campaign allocation amount field, by day type
export const VACATION_DAYS_AMOUNT_FIELDS = {
  cet: 'amount_cet',
  rtt: 'amount_rtt',
  overtime: 'amount_overtime',
  paid_leave: 'amount_paid_leave',
  seniority_leave: 'amount_seniority_leave',
  untaken_rest: 'amount_untaken_rest',
} as const;
